import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { GetList } from "types/data-content";

interface IServicePage {
  pageData: GetList;
}

const HowItWorksSection = ({ pageData }: IServicePage) => {
  return (
    <section className="py-8 sm:py-16 px-6 bg-muted/30">
      <div className="container mx-auto px-4 sm:max-w-6xl">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-0 sm:mb-2 text-foreground">
          {pageData.titleHowItWorks}
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
          {pageData?.steps?.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card 
                key={index} 
                className="border-none shadow-md hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1"
              >
                <CardHeader>
                  <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-lg">{step.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
